import React, { useEffect, useState } from "react";
import axios from "axios";

function NewRoles() {
  const [staffOptions, setStaffOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [newRole, setNewRole] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [staffType, setStaffType] = useState(""); 
  const currentSessionId = localStorage.getItem("currentSessionId");

  useEffect(() => {
    async function fetchData() {
      try {
        // Fetch all staff
        const staffResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/staff/all`);
        setStaffOptions(staffResponse.data);

        // Fetch all roles for current session
        const roleResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/allDesignations/allroles`, {
          params: { sessionId: currentSessionId }
        });
        setRoleOptions(roleResponse.data);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, [currentSessionId]);

  const handleStaffChange = (e) => {
    const staffId = e.target.value;
    setSelectedStaff(staffId);

    // Detect type automatically from selected staff
    const staff = staffOptions.find(s => s._id === staffId);
    if (staff) {
      if (staff.teacherType) setStaffType("Teacher");
      else setStaffType("Non-Teaching");
    } else {
      setStaffType("");
    }
  };

  const handleSubmit = async (e) => {
    const selectedDesignation = roleOptions.find(
  role => role._id === selectedRole
)?.designationName;

    e.preventDefault();

    if (!staffType) {
      return alert("Please select a valid staff member");
    }

    const formData = {
      staffId: selectedStaff,
      roleId: selectedRole,
       usertype: staffType.toLowerCase(), // "teacher" | "non-teacher"
  userTypeReference: newRole || selectedDesignation, // designationName       // optional new designation
      username,
      password,
      sessionId: currentSessionId,
      type: staffType // <-- required by backend
    };

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/roles/assign-role`, formData);
      alert("Role Assigned Successfully ✅");

      // Reset form
      setSelectedStaff("");
      setSelectedRole("");
      setNewRole("");
      setUsername("");
      setPassword("");
      setStaffType("");

    } catch (error) {
      console.error("Error assigning role:", error);
      alert(error.response?.data?.message || "Error assigning role");
    }
  };

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      <div className="w-full border bg-white rounded-lg shadow p-8">
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Staff Selection */}
          <div className="flex flex-col">
            <label className="text-gray-700 font-semibold mb-1">Select Staff</label>
            <select
              value={selectedStaff}
              onChange={handleStaffChange}
              className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 bg-white"
              required
            >
              <option value="">-- Select Staff --</option>
              {staffOptions.map(staff => (
                <option key={staff._id} value={staff._id}>
                  {staff.fullName || staff.name} ({staff.teacherType ? "Teacher" : "Non-Teaching"})
                </option>
              ))}
            </select>
          </div>

          {/* Role Selection */}
          <div className="flex flex-col">
            <label className="text-gray-700 font-semibold mb-1">Select Role</label>
            <select
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
              className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            >
              <option value="">-- Select Role --</option>
              {roleOptions.map(role => (
                <option key={role._id} value={role._id}>
                  {role.designationName} ({role.type})
                </option>
              ))}
            </select>

            {/* Optional: New Role */}
            <input
              type="text"
              placeholder="Or enter new role"
              value={newRole}
              onChange={(e) => setNewRole(e.target.value)}
              className="mt-2 border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            />
          </div>

          {/* Username */}
          <div className="flex flex-col">
            <label className="text-gray-700 font-semibold mb-1">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 bg-white"
              required
            />
          </div>

          {/* Password */}
          <div className="flex flex-col">
            <label className="text-gray-700 font-semibold mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 bg-white"
              required
            />
          </div>

          {/* Submit */}
          <div className="md:col-span-2">
            <button
              type="submit"
              className="w-full bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg shadow transition"
            >
              Assign Role
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default NewRoles;
